// Import of the module

import { formatNumber, parseDate } from "@/lib/utils";
import { ColumnDef } from "@tanstack/react-table";

// Type of the fields in the table

export type Policy = {
  id: number;
  policeable_type: string;
  policeable_id: number;
  app?: number | null;
  path?: string | null;
  policy_method?: string | null;
  created_at: string;
  updated_at: string;
  filter_by_ids?: Record<string, unknown>;
};

// Definition of the columns

export const policies_columns: ColumnDef<Policy>[] = [
  {
    accessorKey: "id",
    header: "Id",
  },
  {
    accessorKey: "policeable_type",
    header: "Policeable Type",
  },
  {
    accessorKey: "policeable_id",
    header: "Policeable ID",
  },
  {
    accessorKey: "app",
    header: "Application",
    cell: ({ row }) => {
      const value = row.getValue("app");
      return value === null || value === undefined || Number.isNaN(value)
        ? ""
        : formatNumber(value as number);
    },
  },
  {
    accessorKey: "path",
    header: "Path",
  },
  {
    accessorKey: "policy_method",
    header: "Policy Method",
  },
  {
    accessorKey: "created_at",
    header: "Created At",
    cell: ({ row }) => parseDate(row.getValue("created_at")),
  },
  {
    accessorKey: "updated_at",
    header: "Updated At",
    cell: ({ row }) => parseDate(row.getValue("updated_at")),
  },
  {
    accessorKey: "filter_by_ids",
    header: "Filter by IDs",
    cell: ({ row }) => {
      const value = row.getValue("filter_by_ids");
      if (
        !value ||
        value === "{}" ||
        (typeof value === "object" && Object.keys(value as object).length === 0)
      ) {
        return "";
      }
      // Display as JSON string for now
      return (
        <pre className="whitespace-pre-wrap text-xs text-muted-foreground">
          {JSON.stringify(value, null, 2)}
        </pre>
      );
    },
  },
];
